import { Button } from "@/components/ui";
import type { FoundField } from "@/hooks/useFindFields";
import { plural } from "@/lib/attributeReview/usedBySummary";
import { cn } from "@/lib/utils";

type Props = {
  field: FoundField;
  current: boolean;
  ai: boolean;
  usedBy: { count: number; stores: number };
  onUse: () => void;
};

const tag = "ml-1.5 rounded-full px-1.5 py-px text-[11px]";

export function FinderResult({ field, current, ai, usedBy, onUse }: Props) {
  return (
    <div
      className={cn(
        "flex items-center justify-between gap-2.5 border-b border-slate-100 px-2.5 py-2 last:border-b-0 dark:border-slate-800/80",
        current
          ? "bg-indigo-500/[0.08]"
          : "hover:bg-slate-50 dark:hover:bg-slate-900",
      )}
    >
      <div className="min-w-0">
        <span className="text-[13px] font-semibold text-slate-900 dark:text-slate-50">
          {field.label}
        </span>
        {ai && (
          <span
            className={cn(
              tag,
              "bg-emerald-500/[0.14] text-emerald-700 dark:text-emerald-300",
            )}
          >
            AI pick
          </span>
        )}
        {current && (
          <span
            className={cn(
              tag,
              "bg-indigo-500/[0.16] text-indigo-700 dark:text-indigo-200",
            )}
          >
            Current
          </span>
        )}
        <span className="mt-0.5 block break-all text-xs text-slate-500 dark:text-slate-400">
          <span className="font-mono">{field.path}</span> ·{" "}
          {usedBy.count
            ? `used by ${plural(usedBy.stores, "other store")}, ${plural(usedBy.count, "product type")}`
            : "no other store yet"}
        </span>
      </div>
      <Button size="sm" variant="outline" disabled={current} onClick={onUse}>
        {current ? "Current" : "Use"}
      </Button>
    </div>
  );
}
